import { render, staticRenderFns } from "./VisaMoreCountry.vue?vue&type=template&id=54544704&scoped=true&"
import script from "./VisaMoreCountry.vue?vue&type=script&lang=js&"
export * from "./VisaMoreCountry.vue?vue&type=script&lang=js&"
import style0 from "./VisaMoreCountry.vue?vue&type=style&index=0&id=54544704&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54544704",
  null
  
)

export default component.exports